<template>
    <div :class="className">
        <label v-if="!href">
            <div>
                <span v-show="!loading">이미지를 첨부해주세요.</span>
                <span class="progress" v-show="loading">이미지 가져오는 중</span>
            </div>
            <input type="file" @change="uploadHandler" accept=".jpg, .png, .jpeg, .gif" />
        </label>
        <div v-else>
            <img :src="href" alt="image" />
            <button class="re-upload" @click="resetHandler">
                다시 업로드하기
            </button>
        </div>
    </div>
</template>

<script>
import api from "@/api";

export default {
    name: "ImageUploader",
    data: () => ({
        href: null,
        loading: false
    }),
    props: ["no", "parentNo", "mode", "type", "status", "value", "isInput", "onChange", "onUpload", "onClearUpload"],
    computed: {
        className() {
            return "image-uploader";
        }
    },
    methods: {
        async uploadHandler(ev) {
            const { files } = ev.target;
            const file = files[0];

            const body = new FormData();
            body.append("upload", file);
            body.append("result_type", "url");

            const { no, parentNo, mode } = this;

            if (file.size > 2097152) {
                this.$alert.danger({ message: "파일은 2MB 이하 크기만 가능합니다." });
                return;
            }

            try {
                this.loading = true;
                const response = await api.fileUpload(body);
                this.href = response;
                this.onUpload({ no, parentNo, mode, value: response });
                this.loading = false;
            } catch (e) {
                this.$alert.danger({ message: e.message });
                this.loading = false;
            }
        },

        resetHandler() {
            const { no, parentNo, mode } = this;

            this.href = null;
            this.loading = false;
            this.onClearUpload({ no, parentNo, mode });
        }
    },
    mounted() {
        if (typeof this.value === "object") {
            if (this.value[0]) {
                this.href = this.value[0];
            }
        }
    }
};
</script>

<style lang="scss">
@keyframes rotate {
    0% {
        transform: rotateZ(0);
    }
    100% {
        transform: rotateZ(360deg);
    }
}

.image-uploader {
    margin: 0 auto;
    font-size: 14px;
    text-align: center;

    label {
        display: flex;
        height: 100px;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        border: 1px solid #ffc964;
        text-align: center;
        color: #686868;
        cursor: pointer;
    }

    .progress::after {
        content: "";
        display: block;
        width: 20px;
        height: 20px;
        margin: 10px auto 0;
        border-width: 3px;
        border-style: solid;
        border-color: #ffc964 #ffc964 #ffc964 #ffe4af;
        border-radius: 50%;
        animation: rotate 2s linear infinite;
    }

    input[type="file"] {
        display: none;
    }

    img {
        display: block;
        margin: 0 auto;
        width: 50%;
    }

    .re-upload {
        cursor: pointer;
        border: none;
        background-color: transparent;
        margin-top: 16px;
        height: 36px;
    }
}
</style>
